
export const initializeAppcues = (id) => {
  if (id && window.Appcues) {
    window.Appcues.identify(id)
    return true
  }
  return false
}

const useAppcues = ({ id }) => {
  let counter = 0
  const interval = setInterval(() => {
    const isLoaded = initializeAppcues(id)
    if (isLoaded || counter > 180) {
      clearInterval(interval)
    }
    counter += 1
  }, 1000)
}

export default useAppcues
